import { FunctionComponent } from 'react'
import { useCart } from '../../../providers/CartProvider'
import { PageDto } from '../../../types/page.types'
import CartItem from './CartItem'

interface Props {
  pageDto: PageDto
  closeCart: () => void
}

const CartItems: FunctionComponent<Props> = ({ pageDto, closeCart }) => {
  const { cart } = useCart()

  if ((cart?.lines || []).length === 0) {
    return null
  }

  return (
    <ul className='flex shrink-0 snap-x snap-mandatory scroll-pl-3 items-stretch overflow-auto pb-5 pt-2'>
      {cart?.lines
        .sort((a, b) => a.merchandise.product.title.localeCompare(b.merchandise.product.title))
        .map((item, i) => <CartItem key={i} pageDto={pageDto} item={item} closeCart={closeCart} className='ml-3 w-40 snap-start last:mr-3' />)}
    </ul>
  )
}

export default CartItems
